import React, { useState } from 'react';
import styled from 'styled-components';

import { getThemeSubCategory, InspirationSubCategoryDefinition, InspirationTheme } from '../../lib/inspiration';
import SideBarTheme from './SideBarTheme';

const SideBarSubCategory = ({ subCat, selectedTheme, onThemeClick }: {
  subCat: InspirationSubCategoryDefinition,
  selectedTheme?: InspirationTheme,
  onThemeClick: (theme: InspirationTheme) => void
}) => {
  const [open, setOpen] = useState(false);
  const isSelected = selectedTheme !== undefined && getThemeSubCategory(selectedTheme)?.id === subCat.id;
  const isOpen = open || isSelected;
  const isSoloSelected = selectedTheme === subCat.themes[0].id && subCat.themes[0]?.solo;

  const onLabelClick = () => {
    if (subCat.themes[0].solo) {
      onThemeClick(subCat.themes[0].id);
    } else {
      setOpen(!open);
    }
  };

  return <Wrapper>
    {
      isSoloSelected ? <>
        <SelectionIndicator/>
        <SelectedSubCat $bold={false}>
          {subCat.label}
        </SelectedSubCat>
      </> : <>
        <SubCat onClick={onLabelClick} $bold={isSelected}>
          {subCat.label}
        </SubCat>
        <Container $height={isOpen ? undefined : 0}>
          {
            subCat.themes.map((theme) => <SideBarTheme
              key={theme.id}
              theme={theme.id}
              selectedTheme={selectedTheme}
              onThemeClick={onThemeClick}
            />)
          }
        </Container>
      </>
    }
  </Wrapper>;
};

const Wrapper = styled.li`
  padding: 0;
  cursor: pointer;
`;

const SubCat = styled.div<{ $bold: boolean }>`
  ${({$bold}) => $bold ? 'font-weight: 700;' : ''}
  padding: 12px 16px 12px 26px;
`;

const SelectionIndicator = styled.div`
  width: 5px;
  height: 50px;
  position: absolute;
  left: 0;
  border-radius: 0 10px 10px 0;
  background: #3BBFD8;
`;

const SelectedSubCat = styled(SubCat)`
  border-radius: 12px;
  background: var(--sp-highlight-bg-color);
`;

const Container = styled.ul<{ $height?: number }>`
  list-style-type: none;
  padding: 0;
  ${({ $height }) => `height: ${$height}px;`}
  overflow: hidden;
`;

export default SideBarSubCategory;
